import Cookies from 'modules/Cookies';
import { loginFacebook, AuthSetDeviceToken } from 'modules/API';
import { FacebookMl3AppLogin, NativeGetDeviceToken } from 'modules/Native';
import { isMl3App } from 'modules/DeviceOptions';
import { sleep } from 'modules/Utils';

/**
 * Facebook login (web)
 */
$(document).on('click', '#fbLogin', () => {
  if (isMl3App) {
    return FacebookMl3AppLogin();
  }

  window.FB.login(
    ({ authResponse: { accessToken } = {} }) => {
      if (!accessToken) {
        // cancelled
        return;
      }

      window.FB.api(
        '/me/?fields=email,gender,name,birthday,picture.height(400)',
        async userResponse => {
          window.freezeModal('#mLogin');
          window.disableElm('#fbLogin');

          try {
            const response = await loginFacebook(window.API.APP.DEVICE, {
              ...userResponse,
              accessToken
            });
            window.loginSuccessDoCookie({
              response
            });
          } catch (e) {
            alert(window.resolveLang('Facebook ログインに失敗しました'));
          }

          window.unfreezeModal('#mLogin');
          window.enableElm('#fbLogin');
        }
      );
    },
    { scope: 'email' }
  );
});

/**
 * Facebook login app (Android and ios Version less than 3.1.0)
 */
const handleAppFacebookLogin = async () => {
  const url = new URL(window.location.href.replace('#', '&'));
  const accessToken = url.searchParams.get('access_token');

  try {
    if (!accessToken) {
      throw new Error();
    }

    const userResponse = await $.ajax({
      url: `https://graph.facebook.com/me/?fields=email,gender,name,birthday,picture.height(400)&access_token=${accessToken}`,
      type: 'GET'
    });

    haflCallAPI({
      ...userResponse,
      accessToken
    });
  } catch (e) {
    alert('Facebook ログインに失敗しました');
    await sleep(100);
    window.location.href = '/startApp.php';
  }
};
window.handleAppFacebookLogin = handleAppFacebookLogin;

/**
 * Handle App Facebook Login Call API
 */
export const haflCallAPI = async (payload, newVersion) => {
  try {
    const { session } = await loginFacebook(window.API.APP.DEVICE, payload);

    Cookies.set('session', session);
    await sleep(10);
    if (newVersion) {
      Cookies.set('do_facebook_native_logout', '1');
    } else {
      Cookies.set('facebook_access_token', payload.accessToken);
    }
    await sleep(10);
    Cookies.set('is_device_id', '0');
    await sleep(10);
    Cookies.originalSet('redirect_to_profile', '1');
  } catch (e) {
    alert('Facebook ログインに失敗しました');
    await sleep(100);
  }

  window.location.href = '/startApp.php';
};

// =====================================

/**
 * Set Device Token
 */
$(document).ready(async () => {
  try {
    if (Cookies.get('session')) {
      const token = await NativeGetDeviceToken();
      await AuthSetDeviceToken({
        session: Cookies.get('session'),
        token,
        setDevice: window.API.APP.DEVICE
      });
    }
  } catch (e) {
    // console.log(e);
  }
});
